import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  automationTypesConfig,
  AutomationTypes,
  AutomationViewGroup,
  DeleteAutomation,
  PauseAutomation,
  UnPauseAutomation,
} from '@tokeet-frontend/automations'
import { ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

@Component({
  selector: 'app-automation-grid-card',
  templateUrl: './automation-grid-card.component.html',
  styleUrls: ['./automation-grid-card.component.scss'],
})
export class AutomationGridCardComponent implements OnInit {
  @Input() automation: AutomationViewGroup
  types = AutomationTypes
  icons = lodash.keyBy(automationTypesConfig, (t) => t.type)

  get automationType() {
    return this.automation.type
  }

  constructor(private store: Store<any>, private confirm: ConfirmDialogService) {}

  ngOnInit(): void {}

  onTogglePause() {
    if (this.automation.status === 1) {
      this.store.dispatch(PauseAutomation({ ids: this.automation.ids }))
    } else {
      this.store.dispatch(UnPauseAutomation({ ids: this.automation.ids }))
    }
  }

  onDelete() {
    this.confirm
      .confirm({
        title: $localize`Delete this Automation?`,
        body: $localize`Are you sure you want to delete this automation?`,
      })
      .subscribe(() => {
        this.store.dispatch(DeleteAutomation({ ids: this.automation.ids }))
      })
  }
}
